import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { contentCardSx } from '../../../../styles/standaloneLayoutTokens';

function formatDateLabel(dateStr) {
  const [, m, d] = dateStr.split('-');
  return `${parseInt(m, 10)}/${parseInt(d, 10)}`;
}

export default function VolumeTrendChart({ data }) {
  const theme = useTheme();

  if (!data || data.length === 0) return null;

  return (
    <Paper elevation={0} sx={{ ...contentCardSx, p: 2.5 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        Daily Check-in Volume
      </Typography>

      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateLabel}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <Tooltip
            labelFormatter={formatDateLabel}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 8,
            }}
          />
          <Legend />
          <Area
            type="monotone"
            dataKey="qr"
            name="QR Check-ins"
            stackId="1"
            stroke={theme.palette.primary.main}
            fill={theme.palette.primary.light}
            fillOpacity={0.5}
          />
          <Area
            type="monotone"
            dataKey="sms"
            name="SMS Check-ins"
            stackId="1"
            stroke={theme.palette.secondary.main}
            fill={theme.palette.secondary.light}
            fillOpacity={0.5}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Paper>
  );
}
